import { useState } from "react";
import NextBatchRegCard from "./../../../CourseRegistration/NextBatchRegCard";

import { getCourseInfo } from "../../../CourseRegistration/admissionDates.js";
import RamadanGroupCard from "../RamadanResult/RamadanGroupCard";
import calculateRemainingDays from "./../../../utils/calculateRemainingDays";
import RefundPolicy from "./../../Aqeedah/RefundPolicy";
import RamadanPayment from "./RamadanPayment";
import RamadanRegistrationForm from "./RamadanRegistrationForm";

export default function RamadanRegistration() {
  const [info, setInfo] = useState({
    gender: "",
    level: "",
    payment: "",
  });

  const courseInfo = getCourseInfo("ramadan-siyam");
  const today = new Date();
  const flexible = new Date(courseInfo.flexibleAdmissionDate);

  // if level 1, then show link fo upcoming batch, if level 2, then show link for running batch, if level 3, then show link for previous batch.
  let updatedBatch = courseInfo.upcomingBatch;
  if (info.level === 3) {
    updatedBatch = courseInfo.upcomingBatch - 2;
  } else if (info.level === 2) {
    updatedBatch = courseInfo.upcomingBatch - 1;
  }
  let updatedLevel = info.level === 2 ? 3 : info.level;

  return (
    <section>
      <div className="container mx-auto my-10 px-5">
        {today > flexible ||
        calculateRemainingDays(courseInfo.admissionStartDate).months > 1 ? (
          <div>
            <p className="text-xl text-blue-600 mt-10 mb-5 text-center">
              ভর্তির সময় শেষ
            </p>
          </div>
        ) : (
          <div>
            <p className="text-xl text-blue-600 mt-10 mb-5 text-center">
              রমাদান ও সিয়াম কোর্সে ভর্তির নিয়ম
            </p>

            <div className="mx-auto my-5 text-center ">
              <ul className="steps steps-vertical">
                <li className="step step-primary">
                  <a href="#send-money">ফী পাঠান</a>
                </li>
                <li className="step step-primary">
                  <a href="#reg-form">ভর্তি ফর্ম পূরণ করুন</a>
                </li>
                <li className="step step-primary">
                  <a href="#group-link">টেলিগ্রাম গ্রুপে জয়েন করুন</a>
                </li>
              </ul>
            </div>
            <RamadanRegistrationForm setInfo={setInfo} />

            <section className="mt-10">
              <div>
                <p className="text-xl text-blue-600 mt-24">গ্রুপে জয়েন করুন</p>
                <p>
                  আপনার পেমেন্ট চেক করে গ্রুপে অ্যাড করা হবে। পেমেন্ট চেক করতে
                  সময় লাগতে পারে।
                </p>
                <p className="mb-5">
                  আপনার কাছে টাকা পাঠানোর (সেন্ডমানি) ছবি বা স্ক্রিনশট থাকলে
                  ইনবক্সে দিবেন। তাহলে দ্রুত গ্রুপে অ্যাড করা সম্ভব হবে।
                </p>

                <div className="w-80 mx-auto lg:mx-0"></div>

                {info.gender && info.level ? (
                  ["paid", "due", "reverted"].includes(info.payment) ? (
                    <div className="w-80 mx-auto lg:mx-0">
                      <RamadanGroupCard
                        batch={updatedBatch}
                        gender={info.gender}
                        level={updatedLevel}
                      />
                    </div>
                  ) : info.payment === "scholarship" ? (
                    <p>
                      আমাদের কোন উস্তাদ / উস্তাদা আপনার সাথে যোগাযোগ করবেন,
                      ইনশাআল্লাহ।
                    </p>
                  ) : (
                    <p></p>
                  )
                ) : (
                  <p>ফর্ম পূরণ করলে এখানে গ্রুপ লিংক দেখাবে।</p>
                )}
              </div>
            </section>

            <section>
              <p className="text-xl text-blue-600 mt-24">সেন্ডমানি করুন</p>
              <RamadanPayment />
            </section>
            <div className="mb-48 ">
              <RefundPolicy />
            </div>
          </div>
        )}
        <NextBatchRegCard course="ramadan-siyam" />
      </div>
    </section>
  );
}
